import { useRouter } from 'next/router';
import React, { FC, ReactNode, useCallback, useEffect, useMemo, useState } from 'react';
import { useEventClickAccordion } from 'src/analytics/useEventClickAccordion';
import { FAQQuestion } from '../types';
import * as S from './styles';

type FAQItemComponent = FC<FAQQuestion>;

export const FAQItem: FAQItemComponent = ({ answer, question, ...rest }) => {
  const { asPath } = useRouter();
  const eventAccordionClick = useEventClickAccordion(question);

  const [isVisible, setIsVisible] = useState(false);

  const handleClick = useCallback(
    () =>
      setIsVisible(isVisible => {
        if (!isVisible) {
          window.dataLayer.push(eventAccordionClick);
        }

        return !isVisible;
      }),
    [eventAccordionClick],
  );

  useEffect(() => () => setIsVisible(false), [asPath]);

  return (
    <S.FAQItemContainer {...rest}>
      <S.TitleWrapper onClick={handleClick} data-testid="switcherButton">
        <S.ArrowIcon $isVisible={isVisible} name="chevronDown" />
        <S.Title>{question}</S.Title>
      </S.TitleWrapper>
      <S.Description $isVisible={isVisible}>
        {typeof answer === 'string' ? <AnswerWithBreaks text={answer} /> : answer}
      </S.Description>
    </S.FAQItemContainer>
  );
};

function AnswerWithBreaks({ text }: { text: string }) {
  return useMemo(() => {
    const textLines = text.split('<br/>');

    return textLines.reduce((res, textLine, index) => {
      res.push(textLine);

      if (index < textLines.length - 1) {
        res.push(<br key={`br-${textLine.slice(0, 10)}`} />);
      }

      return res;
    }, [] as ReactNode[]);
  }, [text]);
}
